'use client';
import { RouterOutputs } from '@streetferret/api';
import { Button } from '@streetferret/ui-web/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@streetferret/ui-web/dropdown-menu';
import { DateRange } from '@streetferret/ui-web/typography/date-range';
import { ChevronsUpDown } from 'lucide-react';
import Link from 'next/link';
import { useRouter } from 'next/navigation';

interface JourneySelectProps {
  slug: string | null;
  journeys: RouterOutputs['journey']['site']['listJourneys'];
}
export function JourneySelect({ slug, journeys }: JourneySelectProps) {
  const router = useRouter();

  const selectedJourney = journeys.find(j => j.journey.slug === slug);
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="lg"
          className="flex items-center justify-between !px-2 !h-auto gap-4">
          {selectedJourney ? (
            <div className="flex flex-col items-start justify-start text-left">
              <span className="text-lg font-bold leading-5">
                {selectedJourney?.journey.name}
              </span>
              <DateRange
                start={selectedJourney?.journey.start}
                end={selectedJourney?.journey.end}
                className="text-muted-foreground"
              />
            </div>
          ) : (
            <span className="text-lg font-bold">Select a journey</span>
          )}
          <ChevronsUpDown className="size-5" />
        </Button>
      </DropdownMenuTrigger>

      <DropdownMenuContent>
        {journeys.map(journey => (
          <DropdownMenuItem key={journey.journey.slug} asChild>
            <Link
              href={
                journey.active ? '/track' : `/track/${journey.journey.slug}`
              }
              className="flex flex-col justify-start !items-start text-left">
              <span className="font-bold">{journey.journey.name}</span>
              <DateRange
                start={journey.journey.start}
                end={journey.journey.end}
                className="text-muted-foreground"
              />
            </Link>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
